import { Controller } from "@hotwired/stimulus"

// Scrollable checkbox picker used in the Review Wizard for authors/categories/tags.
// Handles search filtering + visual "checked" state toggling for the row chrome.
export default class extends Controller {
  static targets = ["list", "row"]

  toggle(event) {
    const row = event.target.closest('[data-checkbox-picker-target="row"]')
    if (row) row.classList.toggle("is-checked", event.target.checked)
  }

  filter(event) {
    const q = event.target.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => {
      const name = row.dataset.name || ""
      const checked = row.querySelector('input[type="checkbox"]')?.checked
      // Always keep checked rows visible so the user never loses their selection.
      row.classList.toggle("hidden", !checked && q !== "" && !name.includes(q))
    })
  }
}
